module.exports = __webpack_public_path__ + "static/media/Lato-Light.90301aa0.woff";